var render = function render(){var _vm=this,_c=_vm._self._c;return _c('server-table-component',{attrs:{"table":"set_relation","schema":"sch_set_relation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }